// extracted by mini-css-extract-plugin
export var navMenu = "NavMenu-module--navMenu--aVuS1";
export var navMenuDrawer = "NavMenu-module--navMenuDrawer--iMCmQ";
export var closeBtn = "NavMenu-module--closeBtn--3n8f5";
export var hidden = "NavMenu-module--hidden--2bu68";
export var navMenuItems = "NavMenu-module--navMenuItems--2sr0C";
export var categoryName = "NavMenu-module--categoryName--nmGub";
export var category = "NavMenu-module--category--c2ysF";
export var categoryToggle = "NavMenu-module--categoryToggle--cZ-jN";
export var categoryPages = "NavMenu-module--categoryPages--2D-R2";